import { Api } from 'common/http';
import { getPlaceSearchAddress, getPlaceSearchQuery } from 'helpers/PlacesHelpers';

export const getPlaceSuggestions = async (query) => {
  try {
    const { data } = await Api.get(`/address-auto-complete/search?streetName=${query}`);
    return data;
  } catch (err) {
    return [];
  }
};

export const getPlaceDetails = async (params) => {
  try {
    const {
      id, street, number, city, province, lat, lng
    } = params;

    if (id) {
      const { data } = await Api.get(`/address-auto-complete/place/${id}`);
      return data;
    }

    const address = getPlaceSearchAddress([street, number]);
    const query = getPlaceSearchQuery({
      city, province, lat, lng
    });

    const { data } = await Api.get(`/address-auto-complete/find/${address}?${query}`);
    return data;
  } catch (err) {
    return {};
  }
};

export const getPlaceDetailsByGeolocation = async (params) => {
  try {
    const { lat, lng } = params || {};
    const { data } = await Api.get(`/address-auto-complete/geo/${lat},${lng}`);
    return data;
  } catch (err) {
    return {};
  }
};
